/**
 * network · consumer entry — calls the shared `bootApp` factory
 * with the consumer's own App component.
 *
 * Mirrors `apps/network/admin/src/main.ts` shape: tiny per-product
 * shell that points the canonical phased boot at the right App.
 * The phased pipeline (DETECT → MOUNT → POST) lives in
 * `apps/network/global/main.ts`; each face brings its own App.
 */
import { bootApp } from "../../global/main.js";
import App from "./App.svelte";

bootApp(App);
